(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CommunicationTypeDialogController', CommunicationTypeDialogController);

    CommunicationTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CommunicationType'];

    function CommunicationTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CommunicationType) {
        var vm = this;
        vm.communicationType = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:communicationTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.communicationType.id !== null) {
                CommunicationType.update(vm.communicationType, onSaveSuccess, onSaveError);
            } else {
                CommunicationType.save(vm.communicationType, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
